export const isOpenFormProtocol = 0x10000;

export const isMemberOnlyLevel = 0x4000000;
